/**
 * シリーズ横断セミナー検索・一覧画面の初期化
 */
export function initPortalWebinarSearch() {
    initCloseDetailSearchButton();
    initOpenDetailSearchButton();
    initAllVenueCheckbox();
    initAllCourseCheckbox();
    initAllOtherCheckbox();
    initKeywordSearch();
}
const hidden = 'hidden';
/**
 * 詳細検索を閉じるボタンの初期化
 */
function initCloseDetailSearchButton() {
    const button = document.getElementById('portal-webinar-search-close-button');
    if (button === null)
        return;
    button.addEventListener("click", () => {
        const closed = document.getElementById('portal-webinar-search-detail-closed');
        if (closed.hasAttribute(hidden)) {
            closed.removeAttribute(hidden);
        }
        const opened = document.getElementById('portal-webinar-search-detail-opened');
        if (!opened.hasAttribute(hidden)) {
            opened.setAttribute(hidden, hidden);
        }
    });
}
/**
 * 詳細検索を開くボタンの初期化
 */
function initOpenDetailSearchButton() {
    const button = document.getElementById('portal-webinar-search-open-button');
    if (button === null)
        return;
    button.addEventListener("click", () => {
        const closed = document.getElementById('portal-webinar-search-detail-closed');
        if (!closed.hasAttribute(hidden)) {
            closed.setAttribute(hidden, hidden);
        }
        const opened = document.getElementById('portal-webinar-search-detail-opened');
        if (opened.hasAttribute(hidden)) {
            opened.removeAttribute(hidden);
        }
    });
}
/**
 * すべて選択チェックボックスの初期化（展示会選択）
 */
function initAllVenueCheckbox() {
    const allCheckbox = document.getElementById('portal-webinar-search-venue-checkbox');
    if (allCheckbox === null)
        return;
    allCheckbox.addEventListener('change', () => {
        const checked = allCheckbox.checked;
        const elements = document.querySelectorAll('[id^=portal-webinar-search-venue-checkbox-]');
        for (const element of elements) {
            const checkbox = element;
            checkbox.checked = checked;
        }
    });
}
/**
 * すべて選択チェックボックスの初期化（コース選択）
 */
function initAllCourseCheckbox() {
    const allCheckbox = document.getElementById('portal-webinar-search-course-checkbox');
    if (allCheckbox === null)
        return;
    allCheckbox.addEventListener('change', () => {
        const checked = allCheckbox.checked;
        const elements = document.querySelectorAll('[id^=portal-webinar-search-course-checkbox-]');
        for (const element of elements) {
            const checkbox = element;
            checkbox.checked = checked;
        }
    });
}
/**
 * すべて選択チェックボックスの初期化（その他）
 */
function initAllOtherCheckbox() {
    const allCheckbox = document.getElementById('portal-webinar-search-other-checkbox');
    if (allCheckbox === null)
        return;
    allCheckbox.addEventListener('change', () => {
        const checked = allCheckbox.checked;
        const elements = document.querySelectorAll('[id^=portal-webinar-search-other-checkbox-]');
        for (const element of elements) {
            const checkbox = element;
            checkbox.checked = checked;
        }
    });
}
/**
 * キーワード検索の初期化
 */
function initKeywordSearch() {
    const input = document.getElementById('portal-webinar-search-input');
    if (input === null)
        return;
    const elements = document.querySelectorAll('.portal-webinar-search-keyword');
    for (const element of elements) {
        const anchor = element;
        anchor.addEventListener("click", () => {
            input.value = anchor.textContent;
        });
    }
}
